/**
 * El backend devuelve el nombre del rol en español (`roleName`), así que lo
 * mapeamos a una clave de i18n para poder mostrarlo en el idioma activo.
 */
export const ROLE_MESSAGE_IDS = {
  Invitado: 'appSections.roles.guest',
  Alumno: 'appSections.roles.student',
  'Alumno Premium': 'appSections.roles.studentPremium',
  Profesor: 'appSections.roles.teacher',
  Administrador: 'appSections.roles.admin',
  Premium: 'appSections.roles.premium',
  Contenidista: 'appSections.roles.contentCreator',
  'Contenidista Global': 'appSections.roles.contentCreatorGlobal',
};

/**
 * Traduce el nombre de un rol. Si el rol no está mapeado devuelve el valor
 * original para no dejar el label vacío.
 * @param {object} intl objeto intl de react-intl
 * @param {string} roleName nombre del rol tal como llega del backend
 * @returns {string}
 */
export const translateRoleName = (intl, roleName) => {
  const messageId = ROLE_MESSAGE_IDS[roleName];
  return messageId ? intl.formatMessage({ id: messageId }) : (roleName || '');
};
